import { NgModule } from '@angular/core';

import { AmaRoutingModule } from './ama-routing.module';
import { AmaComponent } from './ama.component';
import { AskCrownitComponent } from './ask-crownit/ask-crownit.component';
import { AskListComponent } from './ask-list/ask-list.component';
import { AskRequestPreviewComponent } from './ask-request-preview/ask-request-preview.component';
import { DialogComponent } from './dialog/dialog.component';
import { ViewDetailsComponent } from './view-details/view-details.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../core/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    AmaComponent, 
    AskCrownitComponent, 
    AskListComponent, 
    AskRequestPreviewComponent, DialogComponent, ViewDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AmaRoutingModule,
    MaterialModule,
    SharedModule
  ],
  exports:[
    AskCrownitComponent,
    AskListComponent,
    AskCrownitComponent,
    DialogComponent,
  ],
  providers:[
  ]
})
export class AmaModule { }
